// extracted by mini-css-extract-plugin
export default {"row":"Onskt2cZ6JjWLPJyOhYA","box":"T_TspU2WePo7Hl8QnOQD","info":"S2RjvpYIZD_lnuDYsDhz","icon":"WAB9b4axv5GnVifMYC6G"};